import { render, staticRenderFns } from "./ActivitiesCollapse.vue?vue&type=template&id=058d97a2"
import script from "./ActivitiesCollapse.vue?vue&type=script&lang=js"
export * from "./ActivitiesCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports